var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.exportar }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _vm._v(" "),
              _c("span", [_vm._v("Exportar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field select-field--stretch" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_item,
                        expression: "form.tipo_item"
                      }
                    ],
                    attrs: { name: "tipo_item", id: "tipo_item" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo_item",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "T" } }, [_vm._v("Todos")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Productos")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "S" } }, [
                      _vm._v("Servicios")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo_item" } }, [_vm._v("Tipo")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              { staticClass: "form-field select2 select2-field--stretch" },
              [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "categoria",
                        options: _vm.categorias,
                        label: "nombre"
                      },
                      on: { input: _vm.inputCategoria },
                      model: {
                        value: _vm.selectedCategoria,
                        callback: function($$v) {
                          _vm.selectedCategoria = $$v
                        },
                        expression: "selectedCategoria"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "categoria" } }, [
                      _vm._v("Categoría")
                    ])
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              { staticClass: "form-field select2 select2-field--stretch" },
              [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "marca",
                        options: _vm.marcas,
                        label: "nombre"
                      },
                      on: { input: _vm.inputMarca },
                      model: {
                        value: _vm.selectedMarca,
                        callback: function($$v) {
                          _vm.selectedMarca = $$v
                        },
                        expression: "selectedMarca"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "marca" } }, [_vm._v("Marca")])
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12" }, [
            _c("div", { staticClass: "form-inline" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("label", { attrs: { for: "hoy" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipoFecha",
                    id: "hoy",
                    value: "H"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipoFecha", "H")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Hoy")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "ayer" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipoFecha",
                    id: "ayer",
                    value: "A"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipoFecha", "A")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Ayer")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "a_fecha" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipoFecha",
                    id: "a_fecha",
                    value: "F"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "F") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipoFecha", "F")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("A la fecha")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "rango" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipoFecha",
                    id: "rango",
                    value: "R"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "R") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "R")
                      },
                      _vm.changeFechas
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Filtrar por fechas")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipoFecha === "R",
                      expression: "form.tipoFecha === 'R'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("date-picker", {
                        attrs: {
                          name: "fechaDesde",
                          type: "date",
                          format: "dd-MM-yyyy",
                          id: "desde",
                          lang: "es"
                        },
                        model: {
                          value: _vm.form.fechaDesde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fechaDesde", $$v)
                          },
                          expression: "form.fechaDesde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Desde")])
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipoFecha === "R",
                      expression: "form.tipoFecha === 'R'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipoFecha === "R",
                          expression: "form.tipoFecha === 'R'"
                        }
                      ],
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("date-picker", {
                        attrs: {
                          name: "fechaHasta",
                          type: "date",
                          format: "dd-MM-yyyy",
                          id: "hasta",
                          lang: "es"
                        },
                        model: {
                          value: _vm.form.fechaHasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fechaHasta", $$v)
                          },
                          expression: "form.fechaHasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Hasta")])
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.registros.length > 0,
            expression: "registros.length > 0"
          }
        ],
        staticClass: "card"
      },
      [
        _c(
          "div",
          { staticClass: "card__content" },
          [_c("tablaMasVendidos", { attrs: { registros: _vm.registros } })],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout_title" }, [
      _c("h3", [_vm._v("Reporte de productos/servicios más vendidos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("p", [_c("strong", [_vm._v("Fecha:")])])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c7f3710", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c7f3710","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteMasVendidos.vue
// module id = 481
// module chunks = 0